import type { PhoneConfig } from '../utils/contactSubstitution'

export const PHONE_BY_LOCATION: Record<string, PhoneConfig> = {
  'Москва': {
    display: '+7 (495) 868 1619',
    href: '+74958681619',
  },
  'Московская область': {
    display: '+7 (495) 868 1619',
    href: '+74958681619',
  },
  'Московская': {
    display: '+7 (495) 868 1619',
    href: '+74958681619',
  },

  'Санкт-Петербург': {
    display: '+7 (812) 765 0360',
    href: '+78127650360',
  },
  'Ленинградская область': {
    display: '+7 (812) 765 0360',
    href: '+78127650360',
  },
  'Ленинградская': {
    display: '+7 (812) 765 0360',
    href: '+78127650360',
  },

  'Екатеринбург': {
    display: '+7 (343) 288 1370',
    href: '+73432881370',
  },
  'Свердловская область': {
    display: '+7 (343) 288 1370',
    href: '+73432881370',
  },
  'Свердловская': {
    display: '+7 (343) 288 1370',
    href: '+734328813703',
  },

  'Пермь': {
    display: '+7 (342) 264 0429',
    href: '+73422640429',
  },
  'Пермский край': {
    display: '+7 (342) 264 0429',
    href: '+73422640429',
  },
  'Пермская': {
    display: '+7 (342) 264 0429',
    href: '+73422640429',
  },

  'Калининград': {
    display: '+7 (4012) 79-97-52',
    href: '+74012799752',
  },
  'Калининградская область': {
    display: '+7 (4012) 79-97-52',
    href: '+74012799752',
  },
  'Калининградская': {
    display: '+7 (4012) 79-97-52',
    href: '+74012799752',
  },

  'Новосибирск': {
    display: '+7 (383) 205 9840',
    href: '+73832059840',
  },
  'Новосибирская область': {
    display: '+7 (383) 205 9840',
    href: '+73832059840',
  },
  'Новосибирская': {
    display: '+7 (383) 205 9840',
    href: '+73832059840',
  },

  'Челябинск': {
    display: '+7 (812) 408 1913',
    href: '+78124081913',
  },
  'Челябинская область': {
    display: '+7 (812) 408 1913',
    href: '+78124081913',
  },
  'Челябинская': {
    display: '+7 (812) 408 1913',
    href: '+78124081913',
  },


  'Воронеж': {
    display: '+7 (473) 203 1913',
    href: '+74732031913',
  },
    'Воронежская область': {
    display: '+7 (473) 203 1913',
    href: '+74732031913',
  },
    'Воронежская': {
    display: '+7 (473) 203 1913',
    href: '+74732031913',
  },

  'Казань': {
    display: '+7 (843) 254-4635',
    href: '+78432544635',
  },
   'Республика Татарстан': {
    display: '+7 (843) 254-4635',
    href: '+78432544635',
  },
   'Татарстан': {
    display: '+7 (843) 254-4635',
    href: '+78432544635',
  },

  'Курск': {
    display: '+7 (4712) 44 28 12',
    href: '+74712442812',
  },
    'Курская область': {
    display: '+7 (4712) 44 28 12',
    href: '+74712442812',
  },
    'Курская': {
    display: '+7 (4712) 44 28 12',
    href: '+74712442812',
  },

  'Липецк': {
    display: '+7 (4742) 52 19 13',
    href: '+74742521913',
  },
    'Липецская область': {
    display: '+7 (4742) 52 19 13',
    href: '+74742521913',
  },
    'Липецская': {
    display: '+7 (4742) 52 19 13',
    href: '+74742521913',
  },

  'Нижний Новгород': {
    display: '+7 (831) 288 9360',
    href: '+78312889360',
  },
    'Нижнегородская область': {
    display: '+7 (831) 288 9360',
    href: '+78312889360',
  },
    'Нижнегородская': {
    display: '+7 (831) 288 9360',
    href: '++78312889360',
  },

  'Ростов-на-Дону': {
    display: '+7 (863) 309-1945',
    href: '+78633091945',
  },
    'Ростовскя область': {
    display: '+7 (863) 309-1945',
    href: '+78633091945',
  },
    'Ростовская': {
    display: '+7 (863) 309-1945',
    href: '+78633091945',
  },

  'Рязань': {
    display: '+7 (4912) 7224 98',
    href: '+74912722498',
  },
    'Рязанская область': {
    display: '+7 (4912) 7224 98',
    href: '+74912722498',
  },
    'Рязанская': {
    display: '+7 (4912) 7224 98',
    href: '+74912722498',
  },

  'Самара': {
    display: '+7 (846) 233 5247',
    href: '+78462335247',
  },
    'Самарская область': {
    display: '+7 (846) 233 5247',
    href: '+78462335247',
  },
    'Самарская': {
    display: '+7 (846) 233 5247',
    href: '+78462335247',
  },

  'Тула': {
    display: '+7 (4872) 75 19 13',
    href: '+74872751913',
  },
  'Тульская область': {
    display: '+7 (4872) 75 19 13',
    href: '+74872751913',
  },
  'Тульская': {
    display: '+7 (4872) 75 19 13',
    href: '+74872751913',
  },

  'Уфа': {
    display: '+7 (347) 229 2812',
    href: '+73472292812',
  },
  'Ркспублика Башкортостан': {
    display: '+7 (347) 229 2812',
    href: '+73472292812',
  },
  'Башкортостан': {
    display: '+7 (347) 229 2812',
    href: '+73472292812',
  },

  'Ярославль': {
    display: '+7 (4852) 60 81 48',
    href: '+74852608148',
  },
  'Ярославская область': {
    display: '+7 (4852) 60 81 48',
    href: '+74852608148',
  },
  'Ярославская': {
    display: '+7 (4852) 60 81 48',
    href: '+74852608148',
  },
}
